/**
 * @generated SignedSource<<1b153c1710fd5adc67af3d0dd3406cf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AgeRange = "LT12" | "GT12LT19" | "GT20LT24" | "GT25LT29" | "GT30LT34" | "GT35LT39" | "GT40LT44" | "GT45LT49" | "GT50LT54" | "GT55LT59" | "%future added value";
export type AnnualIncome = "LT200" | "GT200LT400" | "GT400LT600" | "GT600LT800" | "GT800LT1000" | "GT1000LT1200" | "GT1200LT1500" | "GT1500LT2000" | "GT2000" | "%future added value";
export type Browser = "IE" | "CHROME" | "SAFARI" | "FIREFOX" | "EDGE" | "OTHER" | "%future added value";
export type DayOfWeek = "SUN" | "MON" | "TUE" | "WED" | "THU" | "FRI" | "SUT" | "%future added value";
export type DeliverKind = "EQUAL" | "WEIGHT" | "%future added value";
export type Device = "MOBILE" | "TABLET" | "PC" | "%future added value";
export type DisplayPopupAgainStatus = "ACTIVE" | "INACTIVE" | "%future added value";
export type DistributionStatus = "ACTIVE" | "INACTIVE" | "%future added value";
export type Gender = "MALE" | "FEMALE" | "%future added value";
export type GroupContentJudgeStatus = "PENDING" | "APPROVED" | "%future added value";
export type ImportAction = "CREATE" | "UPDATE" | "%future added value";
export type MatchOp = "EQUAL" | "CONTAINS" | "%future added value";
export type Platform = "IOS" | "WINDOWS" | "ANDROID" | "MAC" | "LINUX" | "OTHER" | "%future added value";
export type PopupActionKind = "DURATION" | "SCROLL_RATE" | "SCROLL_PIXEL" | "EXIT_PAGE" | "EXIT_AND_SCROLL_RATE_1" | "EXIT_AND_SCROLL_RATE_2" | "EXIT_AND_SCROLL_RATE_3" | "SCROLL_RATE_RANGE" | "CUSTOM_EVENT" | "%future added value";
export type PopupAnimationKind = "NO_ANIMATION" | "FROM_RIGHT" | "FROM_LEFT" | "FROM_TOP" | "FROM_BOTTOM" | "%future added value";
export type PopupCloseButton = "CLOSE_ICON_DEFAULT" | "CLOSE_ICON_JP" | "CLOSE_ICON_EN" | "%future added value";
export type PopupCloseButtonPosition = "TOP_RIGHT" | "TOP_LEFT" | "BOTTOM_LEFT" | "BOTTOM_RIGHT" | "%future added value";
export type PopupClosePopupByClickingOutside = "DISABLED" | "ENABLED" | "%future added value";
export type PopupColorKind = "DEFAULT" | "WHITE" | "GRAY" | "BLACK" | "RED" | "BLUE" | "GREEN" | "YELLOW" | "%future added value";
export type PopupContentKind = "IMAGE" | "VIDEO" | "TEXT" | "HTML" | "%future added value";
export type PopupDisplayKind = "CENTER_MODAL" | "LEFT_MODAL" | "RIGHT_MODAL" | "TOP_MODAL" | "BOTTOM_MODAL" | "LEFT_BOTTOM_MODAL" | "RIGHT_BOTTOM_MODAL" | "CUSTOM_MODAL" | "%future added value";
export type PopupGroupDisplayTargetContentKind = "ID" | "SELECTOR" | "%future added value";
export type PopupHrefTarget = "BLANK" | "TOP" | "%future added value";
export type PopupImportJobStatus = "QUEUED" | "RUNNING" | "COMPLETED" | "COMPLETED_WITH_ERRORS" | "FAILED" | "%future added value";
export type PopupKind = "A_PATTERN" | "B_PATTERN" | "%future added value";
export type PopupYdaTrigger = "YDA_AFFI" | "YDA_ALWAYS" | "YDA_SHOW" | "%future added value";
export type VisitMatch = "EQUAL_MATCH_TYPE" | "OVER_MATCH_TYPE" | "UNDER_MATCH_TYPE" | "%future added value";
export type EnqueuePopupImportInput = {
  clientMutationId?: string | null;
  siteId: string;
  popups: ReadonlyArray<PopupImportRowInput>;
};
export type PopupImportRowInput = {
  action: ImportAction;
  popupId?: string | null;
  popupGroupId?: string | null;
  verification?: PopupImportVerificationInput | null;
  popup: PopupImportPopupInput;
  popupImages?: ReadonlyArray<PopupImportImageInput> | null;
  showPopupAgainImageUrl?: string | null;
  popupGroup?: PopupImportGroupInput | null;
};
export type PopupImportVerificationInput = {
  funnelId?: string | null;
  pageId?: string | null;
};
export type PopupImportPopupInput = {
  actionKind: PopupActionKind;
  animationKind: PopupAnimationKind;
  backgroundOpacity: number;
  button?: string | null;
  buttonGradationColor?: string | null;
  buttonColor?: string | null;
  buttonTextColor?: string | null;
  contentKind?: PopupContentKind | null;
  customEvent?: string | null;
  closePopupByClickingOutside: PopupClosePopupByClickingOutside;
  closeButtonPosition?: PopupCloseButtonPosition | null;
  closeButtonType?: PopupCloseButton | null;
  closeButtonWidth?: number | null;
  isHiddenCloseButton?: boolean | null;
  colorKind?: PopupColorKind | null;
  contentWidth?: number | null;
  spContentWidth?: number | null;
  displayKind?: PopupDisplayKind | null;
  description?: string | null;
  displayOnTabFocus: boolean;
  displayOnMouseOut: boolean;
  enableTapWindow: boolean;
  hideByScrollPercentage: number;
  hideByOnfocus: boolean;
  htmlContent?: string | null;
  hrefTarget: PopupHrefTarget;
  honeycombCode?: string | null;
  isClose: boolean;
  isInheritQuery: boolean;
  name: string;
  quitTiming?: number | null;
  scrollRateRange: string;
  status?: DistributionStatus | null;
  displayCountLimit?: number | null;
  displayPopupAgain?: DisplayPopupAgainStatus | null;
  displayPopupAgainMessage?: string | null;
  kind?: PopupKind | null;
  timing?: number | null;
  titleTextColor?: string | null;
  title?: string | null;
  url?: string | null;
  underlayerColor?: string | null;
  windowColor?: string | null;
  weight?: number | null;
  xOffset?: number | null;
  xOffsetUnit?: string | null;
  ydaTrigger?: PopupYdaTrigger | null;
  yOffset?: number | null;
  yOffsetUnit?: string | null;
  isDisplayWhenNoOperation: boolean;
};
export type PopupImportImageInput = {
  imageUrl?: string | null;
  honeycombCode?: string | null;
  alt?: string | null;
  linkUrl?: string | null;
  isInheritQuery?: boolean | null;
};
export type PopupImportGroupInput = {
  ageRanges?: ReadonlyArray<AgeRange> | null;
  annualIncomes?: ReadonlyArray<AnnualIncome> | null;
  browsers?: ReadonlyArray<Browser> | null;
  deliverDayOfWeeks?: ReadonlyArray<DeliverDayOfWeekInput> | null;
  deliverKind?: DeliverKind | null;
  deliverTargetUrls?: ReadonlyArray<PopupGroupDeliverUrlInput> | null;
  deliverExcludeUrls?: ReadonlyArray<PopupGroupDeliverUrlInput> | null;
  devices?: ReadonlyArray<Device> | null;
  displayTargetContents?: ReadonlyArray<PopupGroupDisplayTargetContentInput> | null;
  disableTargetElements?: ReadonlyArray<PopupGroupDisableTargetElementInput> | null;
  endDate?: string | null;
  excludeReferrers?: ReadonlyArray<PopupGroupExcludeReferrerInput> | null;
  genders?: ReadonlyArray<Gender> | null;
  isMulti?: boolean | null;
  judgeStatus?: GroupContentJudgeStatus | null;
  memo?: string | null;
  name?: string | null;
  platforms?: ReadonlyArray<Platform> | null;
  redisplayPopupTime?: number | null;
  referrers?: ReadonlyArray<PopupGroupReferrerInput> | null;
  sourceIds?: ReadonlyArray<string> | null;
  excludeSourceIds?: ReadonlyArray<string> | null;
  startDate?: string | null;
  status?: DistributionStatus | null;
  targetCookies?: ReadonlyArray<PopupGroupTargetCookieInput> | null;
  visitCount?: number | null;
  visitMatchType?: VisitMatch | null;
  scheduleIds?: ReadonlyArray<string> | null;
};
export type DeliverDayOfWeekInput = {
  weekOfMonth?: number | null;
  daysOfWeek: ReadonlyArray<DayOfWeek>;
};
export type PopupGroupDeliverUrlInput = {
  url: string;
};
export type PopupGroupDisplayTargetContentInput = {
  targetKind: PopupGroupDisplayTargetContentKind;
  targetValue: string;
};
export type PopupGroupDisableTargetElementInput = {
  targetKind: PopupGroupDisplayTargetContentKind;
  targetValue: string;
};
export type PopupGroupExcludeReferrerInput = {
  referrer: string;
  matchOp: MatchOp;
};
export type PopupGroupReferrerInput = {
  referrer: string;
  matchOp: MatchOp;
};
export type PopupGroupTargetCookieInput = {
  key: string;
  value: string;
  matchType: boolean;
};
export type PopupImportContainerEnqueueMutation$variables = {
  input: EnqueuePopupImportInput;
};
export type PopupImportContainerEnqueueMutationVariables = PopupImportContainerEnqueueMutation$variables;
export type PopupImportContainerEnqueueMutation$data = {
  readonly enqueuePopupImport: {
    readonly popupImportJob: {
      readonly slug: string;
      readonly status: PopupImportJobStatus;
      readonly totalCount: number;
    };
  } | null;
};
export type PopupImportContainerEnqueueMutationResponse = PopupImportContainerEnqueueMutation$data;
export type PopupImportContainerEnqueueMutation = {
  variables: PopupImportContainerEnqueueMutationVariables;
  response: PopupImportContainerEnqueueMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupImportContainerEnqueueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EnqueuePopupImportPayload",
        "kind": "LinkedField",
        "name": "enqueuePopupImport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PopupImportJob",
            "kind": "LinkedField",
            "name": "popupImportJob",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupImportContainerEnqueueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EnqueuePopupImportPayload",
        "kind": "LinkedField",
        "name": "enqueuePopupImport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PopupImportJob",
            "kind": "LinkedField",
            "name": "popupImportJob",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c767bc6b551ad1c1e5b47a9c9c28dd86",
    "id": null,
    "metadata": {},
    "name": "PopupImportContainerEnqueueMutation",
    "operationKind": "mutation",
    "text": "mutation PopupImportContainerEnqueueMutation(\n  $input: EnqueuePopupImportInput!\n) {\n  enqueuePopupImport(input: $input) {\n    popupImportJob {\n      slug\n      status\n      totalCount\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "418576672eedd1a085e195bed79bba95";

export default node;
